import React from "react";
import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/motion/Reveal";

const QUOTES = [
  { text: "Gisteravond bij Escape was magisch! Jouw energie en ritme hielden ons de hele nacht in beweging.", author: "Lisa", role: "Escape, Amsterdam" },
  { text: "I truly became your fan after your mesmerizing performance at Gibson last weekend.", author: "Chiran", role: "Gibson, Frankfurt" },
  { text: "Niet normaal hoe je de sfeer aanvoelt en het publiek meeneemt. Dit was een show die ik nooit vergeet!", author: "Martijn", role: "Live Show" },
  { text: "I saw you last night in Escape — you are an incredible performer!", author: "Nico", role: "Escape" },
  { text: "Vanaf de eerste beat had je ons. Dit was next level entertainment!", author: "Sophie", role: "Live Show" },
  { text: "I wish I could hear you live again. You are so incredible live.", author: "Priyank", role: "India" },
  { text: "Gained a fan in Brazil.", author: "Robinho", role: "Brazil" },
  { text: "I'm a big fan of your performance and playing style.", author: "Shabad", role: "Fan" },
];

const Card = ({ q }) => (
  <div className="mx-3 w-[340px] sm:w-[420px] shrink-0 glass rounded-2xl p-8">
    <span className="font-display text-6xl leading-none text-magenta">“</span>
    <p className="-mt-4 text-white/85 leading-relaxed">{q.text}</p>
    <div className="mt-6 border-t border-white/10 pt-4">
      <p className="font-display text-xl tracking-[0.15em] text-white">{q.author}</p>
      <p className="text-xs uppercase tracking-[0.25em] text-gold">{q.role}</p>
    </div>
  </div>
);

export const Testimonials = () => {
  return (
    <section id="testimonials" className="relative py-28 lg:py-36 overflow-hidden">
      <div className="px-6 lg:px-16 max-w-[1400px] mx-auto mb-14">
        <Reveal><span className="text-xs uppercase tracking-[0.4em] text-gold">In Their Words</span></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-3 font-display text-5xl sm:text-6xl lg:text-7xl tracking-wide text-white">WHAT THEY <span className="text-magenta">SAY</span></h2>
        </Reveal>
      </div>
      <Marquee speed={45} gradient={false} pauseOnHover>
        {QUOTES.map((q, i) => <Card key={i} q={q} />)}
      </Marquee>
    </section>
  );
};
